var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrashListIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4470F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.555 3.918v-.47A1.205 1.205 0 0 1 8.76 2.242h.476a1.205 1.205 0 0 1 1.205 1.206v.47M4.172 5.996v-.909A1.16 1.16 0 0 1 5.329 3.93h7.347a1.16 1.16 0 0 1 1.158 1.157v.909z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4470F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.172 5.984h9.662l-1.037 8.733a1.16 1.16 0 0 1-1.15 1.02h-5.29a1.157 1.157 0 0 1-1.149-1.02zM9 7.742v6.095M11.633 7.742l-.578 6.095M6.398 7.742l.58 6.095"
  })));
};
export default SvgTrashListIcon;